import type { DOMOutputSpec, Mark, MarkSpec } from 'prosemirror-model';

import { FontSize, FontSizeMap } from './size-plugin.types';
import type { RtSchemaType } from '../../editor/types';
import { MarkName } from '../../schema/marks';
import type { ProsemirrorAttrs } from '../../schema/schema';

export interface SizeAttrs {
  em: string;
}

export class SizeMark implements MarkSpec {
  public static readonly markName = MarkName.Size;

  public readonly supportedSizes = Object.values(FontSizeMap);

  public attrs: ProsemirrorAttrs<SizeAttrs> = {
    em: {},
  };
  public parseDOM = [
    {
      tag: 'span',
      getAttrs: (dom: HTMLElement): SizeAttrs | false => {
        const fontSize = dom.style.fontSize;
        if (!fontSize) return false;
        const size = fontSize.match(/\d+(\.\d+)?px/)
          ? this.migratePxToEm(parseInt(fontSize.split('px')[0], 10))
          : fontSize.match(/\d+(\.\d+)?em/)
            ? fontSize.split('em')[0]
            : '';

        return size && this.supportedSizes.includes(size) ? { em: size } : false;
      },
    },
  ];

  public toDOM(mark: Mark): DOMOutputSpec {
    const { em } = <SizeAttrs>mark.attrs;
    return ['span', { style: `font-size:${em}em` }];
  }

  private migratePxToEm(px: number): string {
    if (px < 14) return FontSizeMap[FontSize.Small];
    if (px >= 14 && px <= 16) return FontSizeMap[FontSize.Normal];
    if (px > 16 && px <= 18) return FontSizeMap[FontSize.Medium];
    if (px > 18 && px <= 20) return FontSizeMap[FontSize.Large];
    if (px > 20) return FontSizeMap[FontSize.XLarge];
    return FontSizeMap[FontSize.Normal];
  }
}

export type SizeSchema = RtSchemaType<any, typeof SizeMark>;
